import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type CircleProfessionalProps = {
    className?: string;
};

const CircleProfessional: FunctionComponent<CircleProfessionalProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'circle-professional'}
            viewBox="0 0 250 250"
        >
            <path d="M125.4-.1C56.5-.1.4 56 .4 124.9s56.1 125 125 125 125-56.1 125-125-56.1-125-125-125zM46.2 209.6c2.9-2.2 22.5-17 45.7-23.8l5.2 29.9L126 199l28.9 16.7 5.7-29.9c21.5 6.3 39.9 19.4 44.8 23.1-20.8 19.8-49 32-79.9 32-30.7 0-58.6-11.9-79.3-31.3zm165.4-7.2c-4.5-3.5-31.4-23.7-61.5-28.2l-.1.4-24.1 23.5-23.4-22.8-.2-1C70 179.1 41.3 202 40.1 203l3.4 4.2c-21.1-21-34.2-50.1-34.2-82.2 0-64 52-116 116-116s116 52 116 116c0 29.7-11.2 56.8-29.7 77.4z" />
            <path d="M123.3 49.5c-31.4 0-56.9 25.5-56.9 56.9s25.5 56.9 56.9 56.9 56.9-25.5 56.9-56.9-25.6-56.9-56.9-56.9zm0 104.7c-26.4 0-47.9-21.5-47.9-47.9s21.5-47.9 47.9-47.9 47.9 21.5 47.9 47.9-21.5 47.9-47.9 47.9z" />
        </svg>
    );
};
export default CircleProfessional;
